import { useContext, useEffect } from "react";
import { PathMatch, useNavigate, useSearchParams } from "react-router-dom";
import { SessaoContext } from "../Contexts/SessaoContext";

/**
 * Redireciona o usuário para algum lugar caso não tenha nenhuma das permissões listadas. <br/>
 * Por padrão, o usuário é redirecionado para a home.
 */
export const useWatchParameterOnRoutes = (
    options: {
        appliablePaths: (PathMatch | null)[],
        paramToWatch: string,
        onExists: (param: string) => any,
        onNotAccepted?: () => any,
        filters?: [(param: (string | null)) => boolean]
    }
) => { 
    const [searchParams] = useSearchParams()
    useEffect(() => {
        if (options.appliablePaths.every((r) => r == null)) return;

        const param = searchParams.get(options.paramToWatch);
        if (param == null || options.filters?.some((f) => f(param))) {
            options.onNotAccepted?.();
            return;
        }

        options.onExists(param);
    }, [])
}